// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Qaw","colBig":"styles_colBig__14mFg","colSmall":"styles_colSmall__3_W-S","shopifyNameWrapper":"styles_shopifyNameWrapper__3NZEc"};